import React, { useEffect, useState } from "react";
import axios from "axios";
import TrackSearchResult from "../components/TrackSearchResult";

const ListenAndEarn = ({ chooseTrack, playingTrack, accessToken }) => {
    const [campaigns, setCampaigns] = useState([]);

    useEffect(() => {
        const fetchCampaigns = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_BACK4APP_SERVER_PATH}/api/active-campaigns`,
                    { accessToken }
                );
                setCampaigns(response.data.campaigns);
            } catch (error) {
                console.error("Error fetching active campaigns:", error);
            }
        };
    
        if (accessToken) {
            fetchCampaigns();
        }
    }, [accessToken]);
    
    
    return (
        <div className="block-wrapper">
            <h2 className="block-heading">Active Campaigns</h2>
            <div className="track-layout active-campaigns">
                {campaigns.map((campaign) => (
                    <TrackSearchResult
                        track={{
                            title: campaign.trackName,
                            artist: campaign.trackArtist,
                            uri: campaign.trackUri,
                            albumUrl: campaign.trackImage,
                            duration: campaign.trackDuration,
                            pointsFor30Sec: campaign.pointsFor30Sec,
                            pointsForHalf: campaign.pointsForHalf,
                            pointsForFull: campaign.pointsForFull,
                            pointsEnabled: true,
                        }}
                        key={campaign._id}
                        chooseTrack={chooseTrack}
                        playingTrack={playingTrack}
                    />
                ))}
            </div>
        </div>
    );
};

export default ListenAndEarn;